module.exports = __webpack_public_path__ + "static/1-94de1d98693eea5285c00818940319ea.png";